import React from 'react';
import RangeSliderContainer from '../../Componant/Bonus-Ui/RangeSlider';

const RangeSlider = () => {
  return (
    <div className='page-body'>
      <RangeSliderContainer />
    </div>
  );
};

export default RangeSlider;
